import React, { useState, useEffect, } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CustomInput from '../../../components/General/CustomInput';
import _ from 'lodash';
import BodyGrupo from '../../../components/Definitions/Concepts/Grupo/BodyGrupo';

const newInfo = {
    desGrupo: null,
    estado_id: 1,
    edit: 1,
}

const Profile = (props) => {
    const { states, data, setData, getInfo } = props;

    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const addGrupo = () => {
        let updData = _.cloneDeep(data);
        updData?.push(newInfo);
        return setData(updData);
    }

    const handleSearch = (search) => {
        setSearch(search);
        const filtered = data.filter(item =>
            item.desGrupo.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredData(filtered);
    };

    return (
        <div>
            <h1 className='text-center title-page'>Definición de Grupo</h1>
            <div className='row justify-content-center'>
                <div className='col-md-5'>
                    <CustomInput
                        placeholder={'Buscar Grupo'}
                        value={search}
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                </div>
                <div className='col-md-2 d-flex justify-content-evenly align-items-end'>
                    <button className='btn btn-sm btn-primary' type='button' onClick={addGrupo}><AddCircleIcon fontSize='small' /> Crear</button>
                </div>
            </div>
            <div className='row justify-content-center mt-3'>
                <div className='col-md-7 col-sm-10'>
                    <BodyGrupo
                        states={states}
                        data={filteredData.length > 0 ? filteredData : data}
                        setData={setData}
                        getInfo={getInfo}

                    />
                </div>
            </div>
        </div>
    )
}

export default Profile